import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMembers, deleteMember } from '../services/api';

const MemberList = () => {
  const [members, setMembers] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    const { data } = await getMembers(token);
    setMembers(data);
  };

  const handleDelete = async (id) => {
    await deleteMember(id, token);
    fetch();
  };

  return (
    <div className="p-6">
      <Link
        to="/members/new"
        className="mb-4 inline-block px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
      >
        Add Member
      </Link>
      <ul className="space-y-3">
        {members.map(m => (
          <li
            key={m._id}
            className="flex justify-between items-center bg-white p-4 rounded shadow"
          >
            <Link
              to={`/members/${m._id}`}
              className="font-medium hover:text-blue-600"
            >
              {m.firstName} {m.lastName}
            </Link>
           <button
              onClick={() => handleDelete(m._id)}
              className="text-red-500 hover:text-red-700"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>

  );
};

export default MemberList;
